<template>
<div class="mdc-form-field checkbox mdc-typography"
     :class="{'checkbox--invalid': !valid}"
>
  <div class="mdc-checkbox">
    <input type="checkbox"
           class="mdc-checkbox__native-control"
           :id="id"
           :disabled="disabled"
           @change="$emit('input', $event.target.checked)"
           :checked="checked"
    />
    <div class="mdc-checkbox__background">
      <svg class="mdc-checkbox__checkmark"
           viewBox="0 0 24 24"
      >
        <path class="mdc-checkbox__checkmark-path"
              fill="none"
              d="M1.73,12.91 8.1,19.28 22.79,4.59"
        />
      </svg>
      <div class="mdc-checkbox__mixedmark"></div>
      <div class="mdc-checkbox__ripple"></div>
    </div>
  </div>
  <label class="checkbox__label mdc-typography--caption"
         :for="id"
  >
    <slot/>
  </label>
</div>
</template>
<script>

export default {
  name: "bk-checkbox",
  props: {
    label: String,
    checked: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    valid: Boolean,
  },
}
</script>
<style lang="scss" scoped>
  @import "../scss/colors";
  @import "../../node_modules/@material/checkbox/mixins";

  .checkbox {
    display: flex;
    &--invalid {
      & .mdc-checkbox {
        @include mdc-checkbox-container-colors($error, transparent, $primary, $primary, true);
      }
    }

    &__label {
      color: $on-surface;
      display: inline-block;
    }
  }
</style>
